import { App } from '@amzn/monera-app/lib/pages/_app';
import { reportWebVitals as reportWebVitalsAPI } from '@amzn/monera-app/lib/pages/_app';

import '../styles/debug-fix.css';

export default App;
export const reportWebVitals = reportWebVitalsAPI;
